import { toast } from "react-toastify";
import { getAccessToken } from "../../utils/okta-config";
import { API_ROOT } from "../../constants/constants";
import { log } from "../../Helper";

export async function resetOrdersTableData(pageNumber,pageSize) {
  try {
    let url =
      `${process.env.REACT_APP_API_ENDPOINT}/error/errorOrders/` +
      pageNumber +
      `/` +
      pageSize;

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAccessToken()}`,
        "Access-Control-Allow-Origin": API_ROOT,
      },
    };

    const response = await fetch(url, requestOptions);
    // console.log(response)
    const result = await response.json();
    // console.log(result);
    return result.content;
  } catch (error) {
    console.log(error);
  }
}

export async function resetOrdersPostData(reqObj) {

  let url = `${process.env.REACT_APP_API_ENDPOINT}/error/resetOrder`;
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getAccessToken()}`,
      "Access-Control-Allow-Origin": API_ROOT,
    },
    body: JSON.stringify(reqObj),
  };
    const response = await fetch(url, requestOptions);
    const result = await response.json();  
    return result;
}
